import { createFileRoute, Link } from '@tanstack/react-router';
import { useProject } from '@/lib/api/projectApi';
import { Spinner } from '@/components/atoms/Spinner';

export const Route = createFileRoute('/projects/$projectId/intake/submit')({
  component: IntakeSubmitConfirmPage,
});

/**
 * Landing page after a successful intake submit. In F-002 (workspace
 * shell) this will navigate directly into /workspace/overview; for now
 * we show a confirmation + link back home.
 */
function IntakeSubmitConfirmPage() {
  const { projectId } = Route.useParams();
  const project = useProject(projectId);

  if (project.isLoading || !project.data) {
    return <div className="flex min-h-screen items-center justify-center"><Spinner aria-label="Loading" /></div>;
  }

  return (
    <div className="mx-auto max-w-xl p-8">
      <h1 className="font-display text-headline">Intake complete</h1>
      <p className="mt-2 text-body-sm text-muted-foreground">
        <strong>{project.data.name}</strong> moved to <code>intake_complete</code>.
      </p>
      <p className="mt-1 text-caption text-muted-foreground">
        Workspace shell + capital stack views land in the next feature (F-002).
      </p>
      <div className="mt-6 flex gap-3">
        <Link to="/" className="rounded-md border border-border bg-card px-4 py-2 text-foreground">
          Back to home
        </Link>
        <Link
          to="/projects/$projectId/intake/$step"
          params={{ projectId, step: 'basics' }}
          className="rounded-md border border-border bg-card px-4 py-2 text-foreground"
        >
          Edit intake
        </Link>
      </div>
    </div>
  );
}
